import { GetBy } from '../_app/cuchillo/core/Element';
import gsap, { Power2 } from "gsap";
import LogoAnim from '../components/LogoAnim';

export default class Footer  {
  static container = GetBy.id("Footer");
  static _copy = GetBy.class('__copyright', Footer.container)[0];
  static _logo = new LogoAnim(GetBy.class('__logo', Footer.container)[0]);
  static _rrss = GetBy.class('footer__rrss', Footer.container)[0];
  static _legales = GetBy.class('footer__legales', Footer.container)[0];

  static isShow = false;
  static _pointerEvents = "none";

  static show() {
    gsap.killTweensOf(this._copy);
    gsap.killTweensOf(this._rrss);
    gsap.killTweensOf(this._legales);
    gsap.killTweensOf(this.container);
    this.container.style.opacity = 1;
    this.container.classList.add("--show");

    if(this.isShow) return;
    this.isShow = true;
    
    this._logo.show();
    gsap.to(this._copy, {opacity:1, duration:.8, delay:.4, ease:Power2.easeIn});
    gsap.to(this._rrss, {opacity:1, duration:.9, delay:.5, ease:Power2.easeIn});
    gsap.to(this._legales, {opacity:1, duration:1, delay:.6, ease:Power2.easeIn});
  }

  static hide() {
    gsap.killTweensOf(this.container);
    gsap.killTweensOf(this._copy);
    gsap.killTweensOf(this._rrss);
    gsap.killTweensOf(this._legales);
    this.container.classList.remove("--show");
    gsap.to(this._copy, {opacity:0, duration:.4, delay:.4, ease:Power2.easeIn});
    gsap.to(this._rrss, {opacity:0, duration:.4, delay:.4, ease:Power2.easeIn});
    gsap.to(this._legales, {opacity:0, duration:.4, delay:.4, ease:Power2.easeIn});

    gsap.to(this.container, {opacity:0, duration:.4, delay:.1, ease:Power2.easeIn, onComplete:()=> {
      this.isShow = false;
      this._logo.end();
    }});
  }

  static hideLong() {
    gsap.killTweensOf(this.container);
    gsap.killTweensOf(this._copy);
    gsap.killTweensOf(this._rrss);
    gsap.killTweensOf(this._legales);

    this.isShow = false;

    this._logo.hide();
    gsap.to(this._copy, {opacity:0, duration:.2, delay:0, ease:Power2.easeIn});
    gsap.to(this._rrss, {opacity:0, duration:.2, delay:0, ease:Power2.easeIn});
    gsap.to(this._legales, {opacity:0, duration:.2, delay:0, ease:Power2.easeIn});
  }
}


